import { createBrowserRouter } from "react-router-dom";
import Layout from "./Layout";
import Profile from "../pages/Profile";
// import Store from "../pages/Store";
// import Products from "../pages/Products";
// import ShowProduct from "../pages/ShowProduct";
// import ProductList from "../pages/ProductList";
import Login from "../pages/Login";
import PrivateRoute from "./PrivateRoute";
import Error from "../pages/Error";
// import Cart from "../pages/Cart";
import EditProfile from "../pages/EditProfile";
import Register from "../pages/Register";
import Leaderboard from "../pages/Leaderboard";
import PrivateAdminRoute from "./PrivateAdminRoute";
import AdminUserList from "../pages/AdminUserList";
import ProductList from "../pages/ProductList";
import AdminEditProfile from "../pages/AdminEditProfile";
import ResetPassword from "../pages/ResetPassword";
import Users from "../pages/Users";
import Home from "../pages/Home";
import AdminCreateMedal from "../pages/AdminCreateMedal";
import Dashboard from "../pages/Dashboard";
import Community from "../pages/Community";
import CreateCommunity from "../pages/CreateCommunity";
import CommunityDetails from "../pages/CommunityDetails";
import ManageCommunity from "../pages/ManageCommunity";
import Collectionables from "../pages/Collectionables";

const router = createBrowserRouter([
    {
        path: "/",
        element: <Layout />,
        errorElement: <Error />,
        children: [
            {
                path: "/",
                element: <Home />
            },
            {
                path: "/profile/:username",
                element: <Profile />,
            },
            {
                path: "/trainers",
                element: <Users />,
            },
            // {
            //     path: "/store/",
            //     element: <Store />,
            //     children: [
            //         {
            //             path: ":slug?",
            //             element: <Products />,
            //         }
            //     ]
            // },
            // {
            //     path: "/product/:id",
            //     element: <ShowProduct />,
            // },
            {
                path: "/login",
                element: <Login />,
            },
            {
                path: "/register",
                element: <Register />,
            },
            {
                path: "/leaderboard",
                element: <Leaderboard />,
            },
            {
                path: "/collectionables",
                element: <Collectionables />,
            },
            {
                path: "/community",
                element: <Community />,
            },
            {
                path: "/community/:id",
                element: <CommunityDetails />,
            },
            {
                path: "/password/reset/:code",
                element: <ResetPassword />,
            },
        ],
    },
    {
        path: "/",
        element: <PrivateRoute />,
        errorElement: <Error />,
        children: [
            {
                path: "/profile",
                element: <Profile />,
            },
            {
                path: "/profile/edit",
                element: <EditProfile />,
            },
            /*{
                path: "/cart",
                element: <Cart />
            }*/
           {
                path: "/dashboard",
                element: <Dashboard />,
            },
            {
                path: "/community/create",
                element: <CreateCommunity />,
            },
            {
                path: "/community/:id/manage",
                element: <ManageCommunity />,
            },
        ],
    },
    {
        path: "/",
        element: <PrivateAdminRoute />,
        errorElement: <Error />,
        children: [
            {
                path: "/product/list",
                element: <ProductList />,
            },
            {
                path: "/admin/users",
                element: <AdminUserList />,
            },
            {
                path: "/admin/users/:username",
                element: <AdminEditProfile />,
            },
            {
                path: "/admin/medals/create",
                element: <AdminCreateMedal />,
            },
        ],
    },
]);

export default router;
